module.exports = __webpack_public_path__ + "static/img/晚班領班-王偉豊.36d93fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/晚班領班-王偉豊.png
// module id = mtpp
// module chunks = 1